import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import IMGAiFrameHolder from './imga-iframe-holder';
import { isMobile } from '../../../general/js/utils/screen-size-utils';

class IMGAiFrameComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
        this.updateIframeSize();
    }

    updateIframeSize() {
        const {
            iFrameAspectRatioWdith,
            iFrameAspectRatioHeight,
            mobileIFrameAspectRatioHeight,
            mobileIFrameAspectRatioWidth
        } = this.options;

        if (iFrameAspectRatioHeight === '0' &&
            iFrameAspectRatioWdith === '0' &&
            mobileIFrameAspectRatioHeight === '0' &&
            mobileIFrameAspectRatioWidth === '0'
        ) {
            this.element.style.height = '640px';
        } else {
            const desktopPaddingTopPercent = `${(iFrameAspectRatioHeight / iFrameAspectRatioWdith) * 100}%`;
            const mobilePaddingTopPercent = `${(mobileIFrameAspectRatioHeight / mobileIFrameAspectRatioWidth) * 100}%`;

            this.element.style.paddingTop = isMobile() ? mobilePaddingTopPercent : desktopPaddingTopPercent;
        }
    }


    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        const { shotViewScripts, eventCentreParameters } = this.options;

        ReactDOM.render(
            <Fragment>
                <IMGAiFrameHolder
                    eventCentreParameters={eventCentreParameters}
                    shotViewScripts={shotViewScripts}
                />
            </Fragment>,
            this.element
        );
    }
}

export default IMGAiFrameComponent;
